<div class="container">
  <div class="row">
    <div class="col">
      <div class="header">
        <h3 class="title">
          {{ title }}
        </h3>
      </div>
    </div>
  </div>
  <form [formGroup]="form">
    <div class="body">
      <div class="row">
        <div class="col col-2">
          <div class="input mr-lg">
            <app-input
              id="construction_name"
              [label]="'Nome da construtora'"
              maxlength="100"
              formControlName="construction_name"
              [messageError]="'Nome da construtora requerido'"
              [error]="form.get('construction_name').invalid"
              [placeholder]="''"
            ></app-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-3x2">
          <div class="input mr-lg">
            <app-input
              id="administrator_name"
              [label]="'Nome da administradora'"
              maxlength="100"
              formControlName="administrator_name"
              [messageError]="'Nome da administradora requerido'"
              [error]="form.get('administrator_name').invalid"
              [placeholder]="''"
            ></app-input>
          </div>
        </div>
        <div class="col col-3">
          <div class="input">
            <p class="phone-title">Telefone da administradora</p>
            <div class="input-box">
              <app-flag-input
                id="edit-fac-add-phone"
                class="email-input"
                [phone]="administrator_phone"
                [invalid]="administrator_phone.invalid"
              ></app-flag-input>
            </div>
            <div class="error-msg" *ngIf="administrator_phone.invalid">
              <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
              <span>Telefone inválido</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-3x2">
          <div class="input">
            <app-input
              id="janitor_name"
              [label]="'Nome do zelador'"
              maxlength="100"
              formControlName="janitor_name"
              [messageError]="'Nome do zelador requerido'"
              [error]="form.get('janitor_name').invalid"
              [placeholder]="''"
            ></app-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-3x2">
          <div class="input mr-lg">
            <app-input
              id="doorman_name"
              [label]="'Nome do porteiro'"
              maxlength="100"
              formControlName="doorman_name"
              [messageError]="'Nome do porteiro requerido'"
              [error]="form.get('doorman_name').invalid"
              [placeholder]="''"
            ></app-input>
          </div>
        </div>
        <div class="col col-3">
          <div class="input">
            <p class="phone-title">Telefone da portaria</p>
            <div class="input-box">
              <app-flag-input
                id="edit-fac-add-phone"
                class="email-input"
                [phone]="concierge_phone"
                [invalid]="concierge_phone.invalid"
              ></app-flag-input>
            </div>
            <div class="error-msg" *ngIf="concierge_phone.invalid">
              <lib-svg class="error-icon" [icon]="'error_alert_ico'"></lib-svg>
              <span>Telefone inválido</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col col-3x2">
          <div class="input">
            <app-input
              id="sale_pickup"
              [label]="'Captador de venda'"
              maxlength="100"
              formControlName="sale_pickup"
              [messageError]="'Captador de venda requerido'"
              [error]="form.get('sale_pickup').invalid"
              [placeholder]="''"
            ></app-input>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="input">
            <lib-input-checkbox
              class="item-action"
              id="in_pool"
              name="in_pool"
              label="Dentro do pool"
              formControlName="in_pool"
            ></lib-input-checkbox>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
